import { useEffect, useLayoutEffect } from 'react';
/**
 * Custom hook that uses either `useLayoutEffect` or `useEffect` based on the
 * environment (client-side or server-side).
 */
const useIsomorphicLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
export default useIsomorphicLayoutEffect;
